import LegalDocumentView from '../components/LegalDocumentView';
import SiteLayout from '../components/SiteLayout';
import { useLocale } from '../hooks/useLocale';

export default function TermsPage() {
  const { locale, t } = useLocale();

  return (
    <SiteLayout t={t}>
      <LegalDocumentView docKey="terms" locale={locale} labels={t.legalUi.terms} />
    </SiteLayout>
  );
}
